/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_TitleInputs */

const vi_grower_area_public_title = /** @type {(inputs: Grower_Area_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin vùng trồng`)
};

/**

* @param {Grower_Area_Public_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_title = /** @type {((inputs?: Grower_Area_Public_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_title(inputs)
});